const helpers = window.BASE_HELPERS || {};
const { YouTubePlayer, Modal } = helpers;

const MODULE = document.querySelectorAll('[data-module="banner_interno"]');

class BannerInterno {
    constructor() {
        this.components = MODULE;
        this.observer = null;
        this.topOffset = 300;
        this.init();
    }

    async init() {
        this.observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        this.startScrollAnimation(entry.target);
                        this.observer.unobserve(entry.target);
                    }
                });
            },
            {
                threshold: 0.1,
            }
        );

        for (const component of this.components) {
            this.observer.observe(component);

            const videoElement = component.querySelector('[data-youtube-id]');
            if (!videoElement) continue;

            const videoId = videoElement.dataset.youtubeId;
            const elementId = videoElement.id || `yt-${videoId}`;

            await YouTubePlayer.mount({
                videoId,
                elementId,
                playerVars: {
                    controls: 1,
                    muted: 0
                },
                onStateChange: (event) => {
                    switch (event.data) {
                        case YT.PlayerState.PLAYING:
                            YouTubePlayer.pauseOthers(elementId);
                            break;
                        case YT.PlayerState.PAUSED:
                        case YT.PlayerState.ENDED:
                            break;
                    }
                },
            });

            Modal.onOpen = () => {
                YouTubePlayer.play(elementId);
            };

            Modal.onClose = () => {
                YouTubePlayer.pause(elementId);
            };
        };
    }

    easeInOut(t) {
        return t < 0.5
            ? 4 * t * t * t
            : 1 - Math.pow(-2 * t + 2, 3) / 2;
    }

    startScrollAnimation(component) {
        const svg = component.querySelector('svg');
        if (!svg) return;

        const paths = svg.querySelectorAll('path');
        if (!paths.length) return;

        const pathData = [];

        paths.forEach((path) => {
            const length = path.getTotalLength();
            path.style.strokeDasharray = length;
            path.style.strokeDashoffset = length;
            path.style.transition = 'none';
            pathData.push({ path, length });
        });

        const update = () => {
            const rect = component.getBoundingClientRect();
            const viewportHeight =
                window.innerHeight || document.documentElement.clientHeight;

            const endPoint = this.topOffset;
            const total = rect.height + (viewportHeight - endPoint);
            const visible = viewportHeight - rect.top;

            let progress = visible / total;

            progress = Math.max(0, Math.min(1, progress));

            const eased = this.easeInOut(progress);

            pathData.forEach(({ path, length }) => {
                path.style.strokeDashoffset = length * (1 - eased);
            });
        };

        const onScroll = () => window.requestAnimationFrame(update);

        update();
        window.addEventListener('scroll', onScroll, { passive: true });
    }
}

(() => {
    if (MODULE.length) {
        new BannerInterno();
    }
})();

export default BannerInterno;
